// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2ET_t","content":"GlobalSearch_content__2nJAZ"};